import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite/no-important";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import PageTitle from "../components/PageTitle";
import AlertFeedbackPanel from "../components/AlertFeedbackPanel";
import AlertShowItem from "../components/AlertShowItem";
import PopupWrapper from "../components/PopupWrapper";

import { alertsActions } from "../_actions";
import { connect } from "react-redux";

class AssistedLivingAlertsFeedback extends Component {
  constructor(props) {
    super(props);
    const unix = Math.round(+new Date() / 1000);
    this.props.dispatch(
      alertsActions.getDetail(props.authentication.user.dependant_user_id, unix)
    );
  }
  render() {
    let alert = Object.keys(this.props.alerts.detail).filter(item => {
      return (
        this.props.alerts.detail[item].id.toString() ===
        this.props.match.params.alert_id
      );
    });

    return (
      <div>
        <Header
          title={"Parent's Home"}
          backTitle={"Dashboard"}
          isAssistedLiving={true}
          backHref={"/"}
        />
        <PageTitle
          title={"Feedback"}
          subTitle={"We care about all of your feedback."}
        />
        <AssistedLivingNavigation {...this.props.location} />
        <AlertShowItem {...this.props.alerts.detail[alert]} />
        <div className={css([styles.innerNarrow, styles.feedbackContainer])}>
          <PopupWrapper />
          <AlertFeedbackPanel {...this.props} user="dependant" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.alerts;
  const alerts = state.alerts;
  const authentication = state.authentication;
  return {
    fetchingDetail,
    alerts,
    authentication
  };
}

export default connect(mapStateToProps)(AssistedLivingAlertsFeedback);
